export default {
  apiKey: "AIzaSyByhB5gQoOCnMDRJIKG7GhrC848rv8jbxE",
  authDomain: "ambii-prd.firebaseapp.com",
  projectId: "ambii-prd",
  storageBucket: "ambii-prd.appspot.com",
  messagingSenderId: "478909598361",
  appId: "1:478909598361:web:03f5ecd0b3771edf6bc608",
};
